module.exports = __webpack_public_path__ + "static/media/nine-dots.bc5855f8.jpg";